import type { FunctionComponent } from 'react'
import {
  SeoTabs,
  type SeoTabsItem,
} from '@awazevr/design-system.components.seo-tabs'
import type { HeadlineProps } from '@awazevr/design-system.components.text'

export interface SeoTabsModuleProps {
  /** Mapped Headline props — null when no headline configured. */
  headline: HeadlineProps | null
  /** Mapped tabs ready for the design-system primitive. */
  tabs: SeoTabsItem[]
  /** Current page slug; SeoTabs renders links matching slug as plain text. */
  slug?: string
}

export const SeoTabsModule: FunctionComponent<SeoTabsModuleProps> = ({
  headline,
  tabs,
  slug,
}) => {
  if (!tabs.length) return null

  const { children, ...headlineStyling } = headline ?? {}
  return (
    <SeoTabs
      heading={children ?? ''}
      headlineProps={headline ? headlineStyling : undefined}
      tabs={tabs}
      slug={slug}
      backgroundColor={'var(--main-bg-color)'}
      data-testid="seo-tabs-module"
    />
  )
}
